<template>
  <div class="learn-ability-test-test-page-header">
    <img class="learn-ability-test-test-page-header-img"
         :src="imgUrl"
         alt=""
    />
    <div class="learn-ability-test-test-page-header-container">
      <div class="learn-ability-test-test-page-header-container-num">
        <span class="high-light">{{ number }}</span>/6
      </div>
      <div class="learn-ability-test-test-page-header-container-info">
        <div class="learn-ability-test-test-page-header-container-info-title">
          {{ title }}
        </div>
        <div class="learn-ability-test-test-page-header-container-info-summary">
          （多选题）请勾选与实际相符的选项
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'LearnAbilityTestPageHeader',
    props: {
      number: {
        type: Number,
        required: true,
      },
      title: {
        type: String,
        required: true,
      },
    },
    computed: {
      imgUrl() {
        if (this.number === 1) return require('@/pages/2020/LearnAbilityTest/assets/img/block_1.png'); // eslint-disable-line global-require
        if (this.number === 2) return require('@/pages/2020/LearnAbilityTest/assets/img/block_2.png'); // eslint-disable-line global-require
        if (this.number === 3) return require('@/pages/2020/LearnAbilityTest/assets/img/block_3.png'); // eslint-disable-line global-require
        if (this.number === 4) return require('@/pages/2020/LearnAbilityTest/assets/img/block_4.png'); // eslint-disable-line global-require
        if (this.number === 5) return require('@/pages/2020/LearnAbilityTest/assets/img/block_5.png'); // eslint-disable-line global-require
        return require('@/pages/2020/LearnAbilityTest/assets/img/block_6.png'); // eslint-disable-line global-require
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .learn-ability-test-test-page-header {
    position: relative;
    width: 100%;
    height: 280px;
    &-img {
      position: absolute;
      left: 0;
      top: 0;
      z-index: 0;
      display: block;
      width: 100%;
      height: 280px;
    }
    &-container {
      box-sizing: border-box;
      position: relative;
      padding: 70px 0 0 44px;
      z-index: 1;
      display: flex;
      color: @color-white;
    }
    &-container-num {
      margin-right: 48px;
      font-size: 42px;
      line-height: 1;
      .high-light {
        font-size: 72px;
        font-weight: bold;
      }
    }
    &-container-info {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
    &-container-info-title {
      margin-bottom: 20px;
      font-size: 64px;
      font-weight: bold;
      line-height: 1;
      text-shadow: 1px 6px 4px rgba(40, 31, 155, 0.3);
    }
    &-container-info-summary {
      color: #d6e1ff;
      font-size: 30px;
    }
  }

</style>
